import cloneDeep from 'lodash/cloneDeep';
import baseDefaults from '../Base/Base.defaults';

export default {
  ...cloneDeep(baseDefaults),
  items: [],
  iconColor: '#ffffff',
  gap: {
    desktop: 10,
  },
  size: {
    desktop: 20,
  },

  padding: {
    desktop: 2,
  },
  radius: {
    desktop: 200,
  },
};
